import * as types from './constants';

// Verify Merchant
export const verifyMerchantRequest = data => (
  { type: types.VERIFY_MERCHANT_REQUEST, payload: data }
);

export const verifyMerchantDone = data => (
  { type: types.VERIFY_MERCHANT_DONE, payload: data }
);

export const verifyMerchantFailed = errors => (
  { type: types.VERIFY_MERCHANT_FAILED, payload: errors }
);

export const verifyMerchantReset = () => (
  { type: types.VERIFY_MERCHANT_RESET }
);